import { useMountEffect } from "@react-hookz/web";
import React from "react";
import { Container, StyledTickIcon } from "./styles";
export const LoginReminderTooltip = ({
  onImpression
}) => {
  useMountEffect(() => {
    onImpression();
  });
  return /*#__PURE__*/React.createElement(Container, {
    "data-qa": "login-reminder-tooltip"
  }, /*#__PURE__*/React.createElement(StyledTickIcon, null), "Log in again for better content recommendations.");
};
LoginReminderTooltip.displayName = "LoginReminderTooltip";